import React, { useCallback } from 'react';

import { useAppDispatch } from '../../../hooks/react-redux';
import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import { resetPortfolioSurvey, setPortfolioAnalysisPageView, PortfolioAnalysisPage } from './store';
import styles from './PortfolioAnalytics.module.scss';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import { ArrowRight } from '../../shared/icons';

interface PortfolioAnalyticsContinueModalProps {
    isOpen: boolean;
    closeModal: (value: boolean) => void;
}

export const PortfolioAnalyticsContinueModal: React.FC<PortfolioAnalyticsContinueModalProps> = ({ isOpen, closeModal }) => {
    const dispatch = useAppDispatch();

    const startOver = useCallback(() => {
        closeModal(false);
        dispatch(resetPortfolioSurvey());
        dispatch(setPortfolioAnalysisPageView(PortfolioAnalysisPage.SELECT));
    }, [closeModal, dispatch]);

    const confirm = useCallback(() => closeModal(false), [closeModal]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            closeModal={startOver}
            closeLabel='Start Over'
            confirm={confirm}
            confirmLabel='Continue'
            closeOnOverlayClick={false}
            spaceBetweenButtons
        >
            <div className={styles.downloadModal}>
                <ModalHeader
                    label='Portfolio Analysis'
                    testId='portfolio-analytics-continue-modal'
                    marginBottom='0px'
                    icon={ArrowRight}
                />
                <div className={styles.filenameInput}>
                   Would you like to continue with the previous analysis or start again?
                </div>
            </div>
        </ ConfirmationModal>
    );
};
